export default __webpack_public_path__ + "static/media/WaysideTrans.de303a2d.png";